import { EnvironmentType } from '@env/environment.type';

export const environment: EnvironmentType = {
  env: 'dev',
  baseUrl: 'https://int-api-clientes.acciona-energia.com',
  oneLoginIssuer: 'https://acciona-sb.onelogin.com/oidc/2',
  oneLoginClientId: 'ca506b90-2eb3-013c-df90-7672a17da9ed38690',
  oidcRedirect: 'https://int-clientes.acciona-energia.com/comercializadora',
  oidcScope: 'openid profile email',
  azureClientId: '5b886a91-344d-42f7-a38f-20193986cf47',
  azureIssuer: 'https://login.microsoftonline.com/f5fd9e16-114f-4820-8de1-6312daf9aebb/v2.0',
  analyticsId: 'G-M9CDLL7GZ3',
};
